import { Container, Text } from "@mantine/core";

export const Footer = () => {
  return (
    <>
      <Container size="xl">
        <Text ta="center">
          <a href="https://www.vbplus.de/service/rechtliche-hinweise/impressum.html">
            Impressum
          </a>{" "}
          /{" "}
          <a href="https://www.vbplus.de/service/rechtliche-hinweise/datenschutzhinweis-zur-website.html">
            Datenschutz
          </a>
        </Text>
      </Container>
    </>
  );
};
